import { onBeforeMount, ref } from 'vue-demi';
import $t from '../common/i18n';
const { useCommonApi, useBehaviour, useUser, useToast, useEnv } = require('@fegobull/webapi').use;
const { isPreRender } = useEnv();
const request = useCommonApi('self-selected-stocks');
const { runBehaviour } = useBehaviour();
const { isLogin } = useUser();
const { success } = useToast();

export default (stockId) => {
    const selectedStatus = ref(false);

    const getSelectStatus = async () => {
        let res = false;
        const rsp = await request.get('status', { stockId });
        if (rsp.code === 10002) {
            res = false;
        }
        res = rsp?.data?.result ?? false;
        selectedStatus.value = res;
    };

    /**
     * 设置自选状态
     * @param {*} targetStatus 需要设置的自选状态 true:添加自选 false:取消自选
     */
    const setSelectStatus = async ($event, targetStatus) => {
        if (!isLogin) {
            return runBehaviour(null, { type: 'login', withQuery: true }, $event);
        }
        try {
            await request.post(targetStatus ? 'subscribeStock' : 'cancelSubscribeStock', { stockId });
            selectedStatus.value = targetStatus;
            success(targetStatus ? $t('addSelectedSucc') : $t('delSelectedSucc'));
        } catch (err) {
            console.log('set-select-status_error', err);
        }
    };

    const initSelectStatus = async () => {
        if (!stockId || !isLogin) {
            return;
        }
        await getSelectStatus();
    };

    !isPreRender && onBeforeMount(initSelectStatus);

    return {
        selectedStatus,
        setSelectStatus
    };
};
